import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {

	// -------------------------------------------------------------
	// Parallax Banners
	// -------------------------------------------------------------
	function initParallaxBanners () {
		const parallaxBanners = gsap.utils.toArray(".parallax");

		if (!parallaxBanners) {
			return;
		}

		parallaxBanners.forEach(banner => {
			const bannerImages = banner.querySelectorAll(".image-container");

			setParallax(bannerImages[0], 0);
			setParallax(bannerImages[1], 0);
			setParallax(bannerImages[2], 0);
			setParallax(bannerImages[3], 0);
		});

		function setParallax (element, distance) {
			gsap.to(element, {
				scrollTrigger: {
					trigger: element,
					start: "top bottom",
					end: "bottom top",
					scrub: 2,
					invalidateOnRefresh: true,
				},
				y: `-${distance}%`,
			});
		}
	}

	initParallaxBanners();

	// -------------------------------------------------------------
	// Change colour of menu icons on scroll
	// -------------------------------------------------------------

	const sections = document.querySelectorAll("section");
	const menuIcon = document.querySelector(".menu-icon");
	const darkMenuIcon = document.querySelector(".menu-icon-dark");
	const lightMenuIcon = document.querySelector(".menu-icon-light");
	const lightScrollIcon = document.querySelector(".scroll-top-button-light");
	const scrollButtonContainer = document.querySelector(".scroll-top-button-container");

	function toggleMenuColour (section) {
		if (menuIcon) {
			if (section.classList.contains("dark")) {
				lightMenuIcon.classList.add("visible");
				lightScrollIcon.classList.add("visible");
			} else {
				lightMenuIcon.classList.remove("visible");
				lightScrollIcon.classList.remove("visible");

				darkMenuIcon.classList.add("visible");
			}
		}
	}

	// toggleMenuColour(sections[0])

	function toggleScrollIconVisibility () {
		const viewportHeight = window.innerHeight;

		if (window.scrollY >= viewportHeight) {
			scrollButtonContainer.classList.add("visible");
		} else {
			scrollButtonContainer.classList.remove("visible");
		}
	}

	window.addEventListener("scroll", toggleScrollIconVisibility);

	function setTopDistance () {
		if (window.innerWidth < 1024) {
			return 36;
		} else {
			return 56;
		}
	}

	window.addEventListener("resize", () => {
		setTopDistance();
		ScrollTrigger.refresh();
	});

	sections.forEach(((section, index) => {

		const sectionMarginTop = window.getComputedStyle(section).marginTop;

		ScrollTrigger.create({
			trigger: section,
			start: () => {
				return `top-=${sectionMarginTop} top+=${setTopDistance()}`;
			},
			onEnter: () => {
				toggleMenuColour(section);
			},
			onLeaveBack: () => {
				if (index > 0) {
					toggleMenuColour(sections[index - 1]);
				}
			},
			invalidateOnRefresh: true,
		});
	}));

	// -------------------------------------------------------------
	// Scroll to top when you click Top ^ button
	// -------------------------------------------------------------

	const scrollToTopButton = document.querySelector(".scroll-top-button-container");

	scrollToTopButton.addEventListener("click", () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});

});



